import { LEARNING_PATH_HOME_BACKGROUND } from '@common/constant/iconConstant';
import { withTheme } from '@mui/styles';
import theme from 'src/theme';
import styled from 'styled-components';

const ProductCriteriaCertificateBundleStyle = withTheme(styled.div`
  .custom-background {
    position: relative;
    overflow: hidden;
    background: linear-gradient(92.76deg, #17988d 24.56%, #116962 93.61%);
    background: url(${LEARNING_PATH_HOME_BACKGROUND});
    background-size: cover;
    background-position: start;
    background-repeat: no-repeat;
    ${theme.breakpoints.down('sm')} {
      background-position: 20% 0%;
    }

    ${theme.breakpoints.between('md', 'lg')} {
      background-position: 20% 0%;
    }

    min-height: 652px;

    ${theme.breakpoints.up('md')} {
      min-height: 482px;
    }

    ${theme.breakpoints.up('lg')} {
      min-height: 446px;
    }
  }

  .carousel-container {
    position: relative;

    .next-button,
    .previous-button {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      width: 60px;
      height: 60px;
      display: flex;
      align-items: center;
      justify-content: center;
      box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
      background-color: white;
      border-radius: 50%;
      color: ${(props) => props.theme.palette.primary.dark};
      cursor: pointer;
    }

    .next-button {
      right: 130px;
    }

    .previous-button {
      left: 130px;
    }

    @media (max-width: 1200px) {
      .next-button {
        right: 0px;
        width: 60px;
        height: 60px;
      }

      .previous-button {
        left: 0px;
        width: 60px;
        height: 60px;
      }
    }

    /* Adjust button position for mobile */
    @media (max-width: 767px) {
      .next-button {
        top: 33%;
        right: 0px;
        width: 60px;
        height: 60px;
      }

      .previous-button {
        top: 33%;
        left: 0px;
        width: 60px;
        height: 60px;
      }
    }

    @media (max-width: 600px) {
      .next-button {
        top: 31%;
        right: 0px;
        width: 60px;
        height: 60px;
      }

      .previous-button {
        top: 31%;
        left: 0px;
        width: 60px;
        height: 60px;
      }
    }

    @media (max-width: 450px) {
      .next-button {
        top: 28%;
        right: 0px;
        width: 60px;
        height: 60px;
      }

      .previous-button {
        top: 28%;
        left: 0px;
        width: 60px;
        height: 60px;
      }
    }

    @media (max-width: 380px) {
      .next-button {
        top: 26%;
        right: 0px;
        width: 60px;
        height: 60px;
      }

      .previous-button {
        top: 26%;
        left: 0px;
        width: 60px;
        height: 60px;
      }
    }

    @media (max-width: 350px) {
      .next-button {
        top: 24%;
        right: 0px;
        width: 60px;
        height: 60px;
      }

      .previous-button {
        top: 24%;
        left: 0px;
        width: 60px;
        height: 60px;
      }
    }

    @media (max-width: 300px) {
      .next-button {
        top: 20%;
        right: 0px;
        width: 60px;
        height: 60px;
      }

      .previous-button {
        top: 20%;
        left: 0px;
        width: 60px;
        height: 60px;
      }
    }
  }
`);

export default ProductCriteriaCertificateBundleStyle;
